import API from '../api'
import putUrl from './paths'

const updateInvoices = (payload) =>
	new Promise((resolve, reject) => {
		API.put(putUrl.updateInvoices, payload)
			.then((response) => {
				resolve(response)
			})
			.catch((err) => reject(err))
	})

const addOtherInvoiceDocuments = (file, invoiceNumber) =>
	new Promise((resolve, reject) => {
		const formData = new FormData()
		formData.append('file', file)
		API.put(putUrl.addOtherInvoiceDocuments, formData, { invoiceNumber })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => reject(err))
	})

const invoicePaymentAction = ({ action, actionBy, originalInvoiceNo, paymentId }) =>
	new Promise((resolve, reject) => {
		API.put(putUrl.invoicePaymentAction, {}, { action, actionBy, originalInvoiceNo, paymentId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => reject(err))
	})

// Bulk Approve / Reject ALL invoices on a payment. Query params: action, actionBy (user id), paymentId.
const invoicesPaymentAction = ({ action, actionBy, paymentId }) =>
	new Promise((resolve, reject) => {
		API.put(putUrl.invoicesPaymentAction, {}, { action, actionBy, paymentId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => reject(err))
	})


const attachInvoicesToPayment = ({ invoices, paymentId }) =>
	new Promise((resolve, reject) => {
		API.put(putUrl.attachInvoicesToPayment, invoices, { paymentId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => reject(err))
	})

// Cancel a payment. Both values are query params: cancelledBy (logged-in user id) and paymentId.
const cancelInvoicePayment = ({ cancelledBy, paymentId }) =>
	new Promise((resolve, reject) => {
		API.put(putUrl.cancelInvoicePayment, {}, { cancelledBy, paymentId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => reject(err))
	})

export {
	updateInvoices,
	addOtherInvoiceDocuments,
	invoicePaymentAction,
	invoicesPaymentAction,
	attachInvoicesToPayment,
	cancelInvoicePayment,
}
